import { render, staticRenderFns } from "./GymVideoLevelBadge.vue?vue&type=template&id=24a4b720&scoped=true&"
import script from "./GymVideoLevelBadge.vue?vue&type=script&lang=js&"
export * from "./GymVideoLevelBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a4b720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a4b720')) {
      api.createRecord('24a4b720', component.options)
    } else {
      api.reload('24a4b720', component.options)
    }
    module.hot.accept("./GymVideoLevelBadge.vue?vue&type=template&id=24a4b720&scoped=true&", function () {
      api.rerender('24a4b720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/Includes/Badges/GymVideoLevelBadge.vue"
export default component.exports